import { PopOverItemType } from 'components'
import PopOver from 'components/PopOver'
import { PopOverItem, PopOverProps } from 'components/PopOver/types'

type MoreFiltersProps = Omit<PopOverProps<string>, 'options' | 'onChange' | 'isMultiple'> & {
  defaultSelectedOptions?: string[]
  selectedOptions?: PopOverItemType<string>[]
  options: Exclude<PopOverProps<string>['options'], undefined>
  onChange: (value: PopOverItemType<string>[]) => void
}

const MoreFilters = ({ defaultSelectedOptions, options, selectedOptions, onChange, ...props }: MoreFiltersProps) => (
  <PopOver
    color="blue1"
    showArrow={false}
    width={'auto'}
    icon="plus"
    displayValue="more_lbl"
    isMultiple
    options={options}
    {...props}
    onChange={(value?: PopOverItem[]) => {
      if (value === undefined) {
        onChange([])
        return
      }

      onChange(value)
    }}
    value={selectedOptions ?? options.filter((f) => defaultSelectedOptions?.includes(f.value))}
  />
)

export default MoreFilters
